export default __webpack_public_path__ + "static/media/abstract5.4f5bf748.jpg";